export default __webpack_public_path__ + "static/media/close.79ac92a4.svg";